import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const CTA = () => {
    const { t } = useLanguage();
    const styles = {
        section: {
            padding: '120px 32px',
            background: 'linear-gradient(135deg, #E4ECFF 0%, #FFFFFF 50%, #FFE3CC 100%)',
        },
        container: {
            maxWidth: '1000px',
            margin: '0 auto',
            textAlign: 'center',
        },
        h2: {
            fontSize: '48px',
            fontWeight: '800',
            marginBottom: '32px',
            color: '#2B2B2B',
        },
        highlight: {
            background: 'linear-gradient(135deg, #3457D5 0%, #F28C46 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
        },
        card: {
            backgroundColor: '#FFFFFF',
            padding: '48px',
            borderRadius: '24px',
            marginBottom: '48px',
            border: '1px solid #E5E5E5',
            boxShadow: '0 10px 40px rgba(15,15,35,0.08)',
        },
        text: {
            fontSize: '22px',
            color: '#414141',
            lineHeight: '1.7',
            marginBottom: '16px',
        },
        accentText: {
            display: 'block',
            marginTop: '16px',
            color: '#3457D5',
            fontWeight: '700',
            fontSize: '20px',
        },
        question: {
            fontSize: '32px',
            fontWeight: '700',
            color: '#2B2B2B',
            marginBottom: '32px',
        },
        buttonContainer: {
            display: 'flex',
            gap: '20px',
            justifyContent: 'center',
            flexWrap: 'wrap',
            marginBottom: '48px',
        },
        primaryButton: {
            padding: '18px 40px',
            backgroundColor: '#D81F26',
            color: '#FFFFFF',
            fontSize: '16px',
            fontWeight: '600',
            borderRadius: '999px',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.3s',
        },
        secondaryButton: {
            padding: '18px 40px',
            backgroundColor: 'transparent',
            color: '#3457D5',
            fontSize: '16px',
            fontWeight: '600',
            borderRadius: '999px',
            border: '2px solid #3457D5',
            cursor: 'pointer',
            transition: 'all 0.3s',
        },
        footer: {
            backgroundColor: '#F9F9F9',
            padding: '28px',
            borderRadius: '20px',
            border: '1px solid #E5E5E5',
        },
        footerText: {
            fontSize: '15px',
            color: '#6E6E6E',
            lineHeight: '1.7',
        },
    };

    const isMobile = window.innerWidth < 768;
    if (isMobile) {
        styles.section.padding = '60px 20px';
        styles.h2.fontSize = '32px';
        styles.question.fontSize = '24px';
        styles.text.fontSize = '18px';
        styles.card.padding = '32px 24px';
        styles.buttonContainer.flexDirection = 'column';
    }

    return (
        <section style={styles.section}>
            <div style={styles.container}>
                <h2 style={styles.h2}>
                    {t('cta.title')}<span style={styles.highlight}>{t('cta.titleHighlight')}</span>
                </h2>

                <div style={styles.card}>
                    <p style={styles.text}>
                        {t('cta.text')}
                        <span style={styles.accentText}>{t('cta.accentText')}</span>
                    </p>
                </div>

                <h3 style={styles.question}>
                    {t('cta.question')}
                </h3>

                <div style={styles.buttonContainer}>
                    <a href="/signup" style={{ textDecoration: 'none' }}>
                        <button
                            style={styles.primaryButton}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'scale(1.05)';
                                e.target.style.backgroundColor = '#B01820';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'scale(1)';
                                e.target.style.backgroundColor = '#D81F26';
                            }}
                        >
                            {t('cta.buttons.try')}
                        </button>
                    </a>
                    <button
                        style={styles.secondaryButton}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#3457D5';
                            e.target.style.color = '#FFFFFF';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                            e.target.style.color = '#3457D5';
                        }}
                        onClick={() => window.location.href = '/#contact'}
                    >
                        {t('cta.buttons.bookDemo')}
                    </button>
                    <a href="/#contact" style={{ textDecoration: 'none' }}>
                        <button
                            style={styles.secondaryButton}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#3457D5';
                                e.target.style.color = '#FFFFFF';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = 'transparent';
                                e.target.style.color = '#3457D5';
                            }}
                        >
                            {t('cta.buttons.contact')}
                        </button>
                    </a>
                </div>

                <div style={styles.footer}>
                    <p style={styles.footerText}>
                        {t('cta.footer')}
                    </p>
                </div>
            </div>
        </section>
    );
};

export default CTA;
